import { render, staticRenderFns } from "./vue_dropzone.vue?vue&type=template&id=133ba0f0"
import script from "./vue_dropzone.vue?vue&type=script&lang=js"
export * from "./vue_dropzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports